<template>
  <div>
    <v-container fluid class="pt-0">
        <v-layout row wrap class="hide-on-print">
            <v-flex xs12>
                <v-card>
                    <v-tabs
                        fixed-tabs
                        background-color="primary"
                        dark
                        height="40"
                        v-model="tab">
                        <v-tab href="#detail">
                            <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
                            Visa Detail
                        </v-tab>
                        <v-tab href="#history">
                            <v-icon class="mr-2" size="15">mdi-history</v-icon>
                            Visa History
                        </v-tab>

                        <v-btn
                            v-if="visaRequest.extra.apply_type === 'eta'"
                            color="primary"
                            @click="handleNextEta()"
                            class="font-weight-bold text-uppercase px-4 mt-1"
                            style="border: 2px solid white !important;"
                        >
                          <v-icon start size="16">mdi-arrow-right</v-icon>
                          Next ETA
                        </v-btn>


                        <v-tabs-items v-model="tab">
                            <v-tab-item value="detail">
                                <v-card flat class="pb-0" :loading="loading">
<!--                                    {{visaRequest}}-->
                                    <span v-if="visaRequest.old">
                                        <old-visa-detail :visa_request="visaRequest"/>
                                    </span>
                                    <span v-else>
                                    <!-- <paid-visa-detail :visa_request="visaRequest" -->
                                                      <!-- :voucherLoading="voucherLoading" -->
                                                      <!-- :checkPaymentLoading="checkPaymentLoading"/> -->
                                      <conditional-paid-visa-detail v-if="paid && showConditionalPaidVisaDetail" :visa_request="visaRequest"
                                                                    :voucherLoading="voucherLoading"
                                                                    :checkPaymentLoading="checkPaymentLoading"/>
                                       <paid-visa-detail v-if="paid && !showConditionalPaidVisaDetail" :visa_request="visaRequest"
                                                     :voucherLoading="voucherLoading"
                                                     :checkPaymentLoading="checkPaymentLoading"/>
                                      <un-paid-visa-detail :visa_request="visaRequest"
                                                        v-else/>
                                    </span>
                                </v-card>
                            </v-tab-item>

                            <v-tab-item value="history">
                                <v-card flat :loading="loading">
                                  <v-expansion-panels
                                      v-model="panel"
                                      multiple
                                      v-if="visaRequest.visaAssignmentHistory && visaRequest.visaAssignmentHistory.length"
                                      class="mb-4"
                                  >
                                    <v-expansion-panel>
                                      <v-expansion-panel-header class="subtitle-2">Forwarded Tracks</v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <visa-assignment-history :submission_no="visaRequest.submission_no" :history="visaRequest.visaAssignmentHistory" />
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>

                                    <visa-history :alldata="visaRequest" :history="visaRequest.visaHistory" :paid="visaRequest.is_Paid" :assignedUser="visaRequest.assigned_user_for_tippani" :isTippaniVerified="visaRequest.isTippaniVerified"
                                                  :show_load_more="false" :editable="true" :isVisaApproved="visaRequest.approved_at ? true : false"/>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
        <extend-convert-tippani-print-content style="display: none"/>
        <voucher-print-content style="display: none"/>
    </v-container>
  </div>
</template>
<style scoped>

</style>
<script>
    import {mapActions, mapGetters} from "vuex";
    import {required} from "vuelidate/lib/validators";
    import {validationMixin} from "vuelidate";
    import TouristVisa from "@/components/visa-types/confirm/TouristVisa";
    import StudyVisa from "@/components/visa-types/confirm/StudyVisa";
    import BusinessVisa from "@/components/visa-types/confirm/BusinessVisa";
    import RelationVisa from "@/components/visa-types/confirm/RelationVisa";
    import TransitVisa from "@/components/visa-types/confirm/TransitVisa";
    import MarriageVisa from "@/components/visa-types/confirm/MarriageVisa";
    import ResidentialVisa from "@/components/visa-types/confirm/ResidentialVisa";
    import NRNVisa from "@/components/visa-types/confirm/NRNVisa";

    import ApproveModalUI from "@/components/visa/VisaApproveModal";
    import RejectModalUI from "@/components/visa/VisaRejectModal";
    import UnPaidVisaDetail from "./UnPaidVisaDetail";
    import PaidVisaDetail from "./PaidVisaDetail";
    import ConditionalPaidVisaDetail from "./ConditionalPaidVisaDetail";
    import VisaHistory from "./VisaHistory";
    import debouce from 'lodash/debounce'
    import ExtendConvertTippaniPrintContent from "../../../components/visa/ExtendConvertTippaniPrintContent";
    import VoucherPrintContent from "../../../components/visa/VoucherPrintContent";
    import OldVisaDetail from "./OldVisaDetail";
    import ApplicationForm from "./ApplicationForm";
    import visa_request from "../../../store/modules/visa-request/visa_request";
    import VisaAssignmentHistory from "@/views/visa/visa-request/VisaAssignmentHistory.vue";
    import Http from "axios";
    import {API_URL, VERSION} from "../../../config/config";
    import store from "../../../store";

    export default {
        components: {
          VisaAssignmentHistory,
            VisaHistory,
            PaidVisaDetail,
            ConditionalPaidVisaDetail,
            UnPaidVisaDetail,
            "tourist-visa": TouristVisa,
            "approve-modal-ui": ApproveModalUI,
            "reject-modal-ui": RejectModalUI,
            'study-visa': StudyVisa,
            'business-visa': BusinessVisa,
            'relation-visa': RelationVisa,
            'transit-visa': TransitVisa,
            'marriage-visa': MarriageVisa,
            'residential-visa': ResidentialVisa,
            'nrn-visa': NRNVisa,
            ExtendConvertTippaniPrintContent,
            VoucherPrintContent,
            OldVisaDetail,
            ApplicationForm
        },
        mixins: [validationMixin],

        data() {
            return {
                paymentProof: {
                    image: null,
                    url: null,
                    file: null
                },
                tab: null,
                panel: [1, 0],
                valid: true,
                errors: [],
                paymentStatusData: {},
                visaPlanOptions: ["", "Plain", "Single Re-entry", "Multiple Re-entry"]
            };
        },
        validations: {
            paymentStatusData: {
                payment_channel: {required},
                payment_reference_id: {required}
            }
        },
        props: {
            id: String
        },
        computed: {
            ...mapGetters("VisaRequestSingle", ["visaRequest", "loading", "paid", "old", "printType", 'voucherLoading', 'checkPaymentLoading']),
            ...mapGetters("AuthUser", ["user"]),
            approveModal: {
                get() {
                    return this.$store.state.VisaRequestSingle.approveModal;
                },
                set(value) {
                    this.$store.commit("VisaRequestSingle/setApproveModal", value);
                }
            },
            rejectModal: {
                get() {
                    return this.$store.state.VisaRequestSingle.rejectModal;
                },
                set(value) {
                    this.$store.commit("VisaRequestSingle/setRejectModal", value);
                }
            },
            showConditionalPaidVisaDetail(){
              const visa_slugs = ['relation-visa', 'marriage-visa'];
              if(this.visaRequest.visaType && this.visaRequest.visaType.slug){
                return (
                    this.user.from_main_office &&
                    visa_slugs.includes(this.visaRequest.visaType.slug)
                    && this.visaRequest.late_days > 365
                )
              } else {
                return false
              }
            },
        },
        methods: {
          ...mapActions("VisaRequestSingle", [
            "resetState",
            "getVisaRequestDetail",
            "approve"
          ]),
          openLink(url) {
            window.open(url, "_blank");
          },
          approve() {
            this.$store.commit("VisaRequestSingle/setApproveModal", true);
          },
          reject() {
            this.$store.commit("VisaRequestSingle/setRejectModal", true);
          },
          async handleNextEta() {
            try {
              const {data} = await Http.get(API_URL + VERSION + '/visa-requests/get-next-eta');
              if (data.next_id) {
                await this.$router.push({
                  name: 'ViewVisaRequest',
                  params: {id: data.next_id}
                });
              }
            } catch (e) {
              console.log('error', e);
            }
          },
        },
        watch: {
            id: debouce(function (value) {
                this.getVisaRequestDetail(this.id)
                    .catch((e) => {
                        this.$store.commit("VisaRequestSingle/setVisaRequestData", {traveller:{}});
                        if(e.response.status === 404)
                            this.$store.commit("Notification/showError","The Submission number is not found");
                        else
                            this.$store.commit("Notification/showError","Something went wrong");

                    });
            }, 1000)
        },
        mounted() {
            if (this.id) {
                this.getVisaRequestDetail(this.id)
                    .catch((e) => {
                        this.$store.commit("VisaRequestSingle/setVisaRequestData", {traveller:{}});
                        if(e.response.status === 404)
                            this.$store.commit("Notification/showError","The Submission number is not found");
                        else
                            this.$store.commit("Notification/showError","Something went wrong");
                    });
            }
        }
    };
</script>
